<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right"></div>
    <div class="ir-line-content">
      <span>{{ 'settings.translations.translations' | translate }}</span>
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="ir-section--admin th-section--admin">
    <div class="ir-content-fixed th-content">
      <h1>
        <span *ngIf="currentPerson && currentPerson.name">{{ currentPerson.name }}</span>
        <span *ngIf="currentPerson && !currentPerson.name">{{ currentPerson.email }}</span>
      </h1>
      <div class="ir-position--b th-home">
        <div class="ir-bloc ir-ph4 ir-pv4">
          <div class="ir-row">
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <div (click)="exportTranslations()" class="ir-btn ir-btn--big ir-btn--block th-btn-action">
                <span>{{ 'settings.translations.export-translations' | translate }}</span>
              </div>
            </div>
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <div class="ir-inputfile" *ngIf="!loading">
                <input
                  type="file"
                  name="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  (change)="uploadTranslations($event)"
                  id="file"
                />
                <label for="file" class="ir-btn ir-btn--big ir-btn--block th-btn-action">
                  <span>{{ 'settings.translations.upload-translations' | translate }}</span>
                </label>
              </div>
              <div class="ir-btn ir-btn--big ir-btn--block th-btn-action th-btn-disabled" *ngIf="loading">
                <span>{{ 'common.processing' | translate }}...</span>
              </div>
              <!-- <div (click)="uploadTranslations()" class="ir-btn ir-btn--big ir-btn--block th-btn-action">
                                <span>{{ 'settings.translations.upload-translations' | translate  }}</span>
                            </div> -->
            </div>
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <div class="ir-inputfile" *ngIf="!loading">
                <input
                  type="file"
                  name="translationfile"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  (change)="uploadTranslationFiles($event)"
                  id="translationfile"
                />
                <label for="translationfile" class="ir-btn ir-btn--big ir-btn--block th-btn-action">
                  <span>{{ 'settings.translations.upload-data-translations' | translate }}</span>
                </label>
              </div>
              <div class="ir-btn ir-btn--big ir-btn--block th-btn-action th-btn-disabled" *ngIf="loading">
                <span>{{ 'common.processing' | translate }}...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
